import React from 'react';

import clsx from 'clsx';

import styles from './ButtonLoader.module.scss';

export type ButtonLoaderVariant = 'primary' | 'dark' | 'white';

interface ButtonLoaderProps {
  className?: string;
  variant?: ButtonLoaderVariant;
}

const getStyleByButtonLoaderVariant = (variant: ButtonLoaderVariant) => {
  switch (variant) {
    case 'dark': {
      return styles.dark;
    }
    case 'white': {
      return styles.white;
    }
    default: {
      return styles.primary;
    }
  }
};

const ButtonLoader = ({ className, variant = 'primary' }: ButtonLoaderProps) => {
  const loaderClass = clsx(styles.container, getStyleByButtonLoaderVariant(variant), className);

  return (
    <div className={loaderClass}>
      <div className={clsx(styles.dot, styles.left)} />
      <div className={clsx(styles.dot, styles.middle)} />
      <div className={clsx(styles.dot, styles.right)} />
    </div>
  );
};

export default ButtonLoader;
